<template>
  <div class="menuFrame">
    <loading :active.sync="isLoading"></loading>

    <div id="track">
      <div class="d-flex justify-content-between">
        <div>
          <a href="/ExhibitorServiceTW/en" class="Breadcrumb"> Exhibition List</a><span>/</span>
          <em name="Exhibition"></em> <span>/</span>VIP Invitation
        </div>
        <div>
          <span class="bold">Account :</span>
          <span> {{ UserId }}</span>
        </div>
      </div>
    </div>
    <!-- track end -->
    <!-- article -->

    <div>
      <div class="MbDevice">
        <div class="homeLeft mt-5">
          <div class="UserAccount ml-1">
            <span class="bold">Account :</span>
            <span> {{ UserId }}</span>
          </div>
          <hr />
          <div class="expoLogo"><img :src="ExhLogo" width="100%" /></div>
          <div class="expoInfo">
            <p class="bold" name="Exhibition"></p>
            <p>{{ ExhBegin }} - {{ ExhEnd }}</p>
            <p>{{ eExhVenue }}</p>
          </div>
          <p class="clear"></p>
        </div>
      </div>

      <div class="articleEn">
        <div>
          <div class="PcDevice">
            <div class="contentBoxStatus py-3">
              <div class="d-flex align-items-center justify-content-around">
                <div
                  v-for="(item, index) in MenuInvitation"
                  :key="index"
                  class="btn btn-white py-2 px-4"
                  style="border-radius: 20px; border-color: #d9d9d9"
                  @click="InviteLink(item.Url)"
                >
                  <span
                    class="font-weight-bold text-primary"
                    style="font-size: 16px"
                    v-if="item.MenuName == 'VIP Invitation'"
                  >
                    <i class="fas fa-caret-right"></i> {{ item.MenuName }}
                  </span>
                  <span v-else> <i class="fas fa-caret-right"></i> {{ item.MenuName }} </span>
                </div>
              </div>
            </div>
            <div class="my-3"></div>
          </div>

          <div class="contentBox">
            <!-- left -->
            <div class="proLeft NoShowInMobile align_c">
              <img src="../../../assets/images/iconVip.svg" width="100%" />
            </div>
            <!-- left end -->
            <!-- right -->
            <div class="proRight">
              <div class="MbDevice">
                <!-- <h1> <img src="../images/iconVIP.svg" width="35px" class="mb-2"> VIP Invitation</h1> -->

                <div class="d-flex justify-content-between align-items-center">
                  <!-- <div>
                    <h1><img src="../../../assets/images/iconVip.svg" width="35px" class="mb-2" /> VIP Invitation</h1>
                  </div> -->

                  <div class="d-flex align-items-center">
                    <div>
                      <img src="@/assets/images/iconVip.svg" width="35px" class="mt-1 mr-1" />
                    </div>
                    <div>
                      <h1>VIP Invitation</h1>
                    </div>
                  </div>

                  <div class="mb-2">
                    <el-dropdown>
                      <span class="el-dropdown-link">
                        <span class="border py-1 px-3">
                          <i class="fas fa-ellipsis-h"></i>
                        </span>
                      </span>
                      <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item v-for="(item, index) in MenuInvitation" :key="index">
                          <span class="MbListGray" @click="InviteLink(item.Url)"> {{ item.MenuName }} </span>
                        </el-dropdown-item>
                      </el-dropdown-menu>
                    </el-dropdown>
                  </div>
                </div>
              </div>
              <div class="PcDevice">
                <h1>VIP Invitation</h1>
              </div>
              <p class="my-3">&nbsp;</p>
              <p>
                You can provide an exclusive VIP badge for your most important clients. Those invited may acquire their
                VIP badge with their business cards at the VIP Check-in counter onsite.
              </p>
              <p class="my-3">&nbsp;</p>
              <ol class="number">
                <li>There is a limited quota</li>
                <li>
                  Application deadline: <span class="red"><span name="CloseDay"></span> 17:00 </span>
                </li>
                <li>VIP Badge can be used only during the exhibition period</li>
              </ol>
              <p class="my-3">&nbsp;</p>
              <div class="grayBG">
                Quantity of Invitation：<span class="red" name="TotalVipRegistered"></span> /
                <span name="VipInvitationQuota"></span>
                <a
                  :href="`https://www.chanchao.com.tw/ExhibitorServiceTW/en/inviteVIPList?no=${RegNo}`"
                  data-fancybox
                  data-options='{"type" : "iframe", "iframe" : {"preload" : false, "css" : {"width" : "1000px"}}}'
                  data-type="iframe"
                  class="link iframeFormCard AddRegLink linkstyle"
                >
                  <br />
                  View Details <i class="fas fa-external-link-alt ml-2 text-primary" style="font-size: 15px"></i
                ></a>
              </div>

              <p class="my-3">&nbsp;</p>
              <a
                :href="`https://www.chanchao.com.tw/ExhibitorServiceTW/en/inviteVIPApply?no=${RegNo}`"
                data-fancybox
                data-options='{"type" : "iframe", "iframe" : {"preload" : false, "css" : {"width" : "1000px"}}}'
                data-type="iframe"
                class="btnStyle iframeForm AddRegLink"
                >Invite</a
              >
            </div>
            <p class="clear"></p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import $ from 'jquery'
  import axios from 'axios'

  export default {
    metaInfo() {
      return {
        title: `VIP Invitation - Chan Chao Exhibitor's Online Service System`,
      }
    },

    data() {
      return {
        UserId: '',
        RegNo: '',
        VipName: '',
        VipCompany: '',
        lang: 'en',
        MenuInvitation: [],
        ExhLogo: '',
        ExhBegin: '',
        ExhEnd: '',
        ExhVenue: '',
        eExhVenue: '',
      }
    },

    methods: {
      InviteLink(Url) {
        const vm = this
        if (vm.lang == 'tw') {
          document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/${Url}?no=${vm.RegNo}`
        } else {
          document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/en/${Url}?no=${vm.RegNo}`
        }
      },
    },

    created() {
      const vm = this

      //url取出展碼
      let currentUrl = location.href
      vm.RegNo = currentUrl.split('no=')[1]

      //取得語系

      let lang = 'en'

      //取得邀請選單
      axios
        .get(`https://www.chanchao.com.tw/apiExhibitors/MenuInvitation/${vm.RegNo}?lang=${vm.lang}`)
        .then((response) => {
          // console.log(response.data)

          vm.MenuInvitation = response.data.Data
        })

      axios.get(`https://www.chanchao.com.tw/apiExhibitors/Exhibition/${vm.RegNo}?lang=${vm.lang}`).then((response) => {
        vm.ExhLogo = `//www.ccie.com.tw/exhibition/images/exlogo/${response.data.Data.ExhLogo}`
        vm.ExhBegin = response.data.Data.ExhBegin
        vm.ExhEnd = response.data.Data.ExhEnd
        vm.ExhVenue = response.data.Data.ExhVenue
        vm.eExhVenue = response.data.Data.eExhVenue
      })

      axios.get(`https://www.chanchao.com.tw/apiExhibitors/UserID`).then((response) => {
        vm.UserId = response.data
      })

      $.getJSON('/apiExhibitors/Exhibition/' + vm.RegNo, { lang: lang }, function (data) {
        // console.log(data.Data)
        $('[name="ExhTime"]').text(data.Data.ExhTime)
        //close day

        // console.log(data.Data.ExhBegin)

        //設定開展前七天
        var CloseDay = new Date(data.Data.ExhBegin)
        // console.log(CloseDay)
        CloseDay.setDate(CloseDay.getDate() - 7)
        $('[name="CloseDay"]').text(formatDate(CloseDay))
        function formatDate(date) {
          var d = new Date(date),
            month = '' + (d.getMonth() + 1),
            day = '' + d.getDate(),
            year = d.getFullYear()
          if (month.length < 2) month = '0' + month
          if (day.length < 2) day = '0' + day
          return [year, month, day].join('/')
        }

        //當前時間 Timestamp
        var currentdate = Date.parse(new Date()).valueOf()
        // console.log(currentdate)

        //開展前七天日期 + 17:00 Timestamp
        var ExhTime = Date.parse(CloseDay) + 61200000
        // console.log(ExhTime)

        if (currentdate > ExhTime) {
          if (lang == 'tw') {
            $('.btnStyle').addClass('btnExpire')
          } else {
            $('.btnStyle').addClass('ebtnExpire')
          }
          $('form').remove()
        }
      })

      //InvTotal
      $.getJSON('/apiExhibitors/ClientVIPTotal_Quota/' + vm.RegNo, function (data) {
        // console.log(data.Data)
        $('[name="VipInvitationQuota"]').text(data.Data.VipInvitationQuota)
        $('[name="TotalVipRegistered"]').text(data.Data.TotalVipRegistered)

        //判斷VIP是否額滿
        if (data.Data.VipInvitationQuota == data.Data.TotalVipRegistered) {
          if (lang == 'tw') {
            $('.btnStyle').addClass('btnFull')
          } else {
            $('.btnStyle').addClass('ebtnFull')
          }
        }
      })

      // $.fancybox.open({
      //   opts: {
      //     afterClose: function (instance, current) {
      //       console.info('done22!')
      //     },
      //   },
      // })

      // function iframeForm() {
      //   alert(4)

      // $(function () {
      //   alert(3)
      // $('.iframeForm').fancybox({
      //   iframe: {
      //     css: {
      //       width: '1000px',
      //       height: '100%',
      //     },
      //   },
      // })

      //   $('.iframeFormCard').fancybox({
      //     afterClose: function () {
      //       window.location.reload()
      //     },
      //     iframe: {
      //       css: {
      //         width: '1000px',
      //         height: '100%',
      //       },
      //     },
      //   })
      // })

      // }
    },
  }
</script>

<style lang="scss">
  a:hover {
    color: #ffffff;
  }

  .linkstyle:hover {
    color: #0056b3;
  }
  .Breadcrumb:hover {
    color: #3153f8db;
  }
</style>
